// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"black-friday-banner_saveTag__WXG_K","text":"black-friday-banner_text__DvIkg"};